import {
  type LatestTimeSeriesItem,
  useGetLatestTimeSeriesDataV2ReportTimeSeriesLatestPost,
} from "kubb";
import type React from "react";
import { ErrorBanner } from "../../../components/Error/ErrorBanner";
import BlockSpinner from "../../../components/Spinners/BlockSpinner";
import { useGetDataNew } from "../../../hooks/getData";
import type { LatestDataReportParams } from "./model";

export type LatestTimeSeriesResponse = Array<LatestTimeSeriesItem>;

export interface LatestTimeSeriesReportProps {
  error?: Error;
  data?: LatestTimeSeriesResponse;
  loading: boolean;
}

export interface LatestTimeSeriesReportRequest extends LatestDataReportParams {
  company_id: string;
  scheme_id: string;
}

const LatestTimeSeriesApiWrapper = (props: {
  request: LatestTimeSeriesReportRequest;
  children: (props: LatestTimeSeriesReportProps) => React.ReactNode;
}): React.ReactElement => {
  const { company_id, scheme_id, ...rest } = props.request;
  const { data, error, loading } = useGetDataNew<LatestTimeSeriesResponse>(() =>
    useGetLatestTimeSeriesDataV2ReportTimeSeriesLatestPost(
      {
        company_id,
        scheme_id,
        ...rest,
      },
      {
        company_id,
      },
    ),
  );

  return (
    <>
      {!loading && error && <ErrorBanner error={error} />}
      <BlockSpinner loading={loading}>
        {props.children({ error: error || undefined, data, loading })}
      </BlockSpinner>
    </>
  );
};

export default LatestTimeSeriesApiWrapper;
